import hashHistory from './history';
import configureStore from './configureStore';
import rootReducer from '../reducers/index';
import rootSaga from '../sagas/index';

const initialState = {};
const { store, history } = configureStore(
    rootReducer,
    rootSaga,
    hashHistory,
    initialState,
);
export { store, history };


// WEBPACK FOOTER //
// ./src/store/store.js